import { VolumeUnits, WeightUnits } from '../graphql';

interface CapacityUnit {
  symbol: string;
}

export const volumeCapacityUnits: Record<VolumeUnits, CapacityUnit> = {
  [VolumeUnits.DT]: { symbol: 'dt' },
  [VolumeUnits.FT_3]: { symbol: 'ft³' },
  [VolumeUnits.FT_UK]: { symbol: 'ft uk' },
  [VolumeUnits.FT_US]: { symbol: 'ft uk' },
  [VolumeUnits.GRT]: { symbol: 'grt' },
  [VolumeUnits.LCBM]: { symbol: 'lcm' },
  [VolumeUnits.LITER]: { symbol: 'l' },
  [VolumeUnits.M_3]: { symbol: 'cbm' },
  [VolumeUnits.M_3_RW]: { symbol: 'm³rw' },
  [VolumeUnits.M_3_TO]: { symbol: 'm³to' },
  [VolumeUnits.SCBM_OB]: { symbol: 'scbm ob' },
  [VolumeUnits.SCBM_UB]: { symbol: 'scbm ub' },
  [VolumeUnits.TEU]: { symbol: 'teu' },
};

export const massCapacityUnits: Record<WeightUnits, CapacityUnit> = {
  [WeightUnits.ADMT]: { symbol: 'admt' },
  [WeightUnits.BDMT]: { symbol: 'bdmt' },
  [WeightUnits.GMT]: { symbol: 'gmt' },
  [WeightUnits.KG]: { symbol: 'kg' },
  [WeightUnits.LONGTON]: { symbol: 'long ton' },
  [WeightUnits.POUND]: { symbol: 'lb' },
  [WeightUnits.SHORTTON]: { symbol: 'short ton' },
  [WeightUnits.TONNE]: { symbol: 'mts' },
};

export const getVolumeUnitName = (
  unit: VolumeUnits | null | undefined,
): CapacityUnit | null => (unit == null ? null : volumeCapacityUnits[unit]);
export const getMassUnitName = (
  unit: WeightUnits | null | undefined,
): CapacityUnit | null => (unit == null ? null : massCapacityUnits[unit]);

export const capacityUnits = {
  ...volumeCapacityUnits,
  ...massCapacityUnits,
};

export const massUnitOptions = Object.keys(massCapacityUnits).map(
  (key: WeightUnits) => ({
    name: massCapacityUnits[key].symbol,
    id: key,
  }),
);

export const volumeUnitOptions = Object.keys(volumeCapacityUnits).map(
  (key: VolumeUnits) => ({
    name: volumeCapacityUnits[key].symbol,
    id: key,
  }),
);
